import React, { Component } from "react";
import { reduxForm, Field, FieldArray } from "redux-form";
import { push } from "react-router-redux";
import { Element } from "react-scroll";
//import Tooltip from 'material-ui/IconButton';
import Info from "material-ui/svg-icons/action/info-outline";
import Input from "../../../../../components/form/Input";
import Select from "../../../../../components/form/Select";
import DatePicker from "../../../../../components/form/DateTime";
import Button from "../../../../../components/form/Button";
import { ReduxCheckbox } from "../../../../../components/form/Checkbox";
import CroField from "../../../components/generalForm/CroField";
import CroSubhead from "../../../components/generalForm/CroSubhead";
import CroSubheadWithCheck from "../../../components/generalForm/CroSubheadWithCheck";
import CroMunicipality from "../../../components/generalForm/CroMunicipality";
import CroCountry from "../../../components/generalForm/CroCountry";
import { asyncForm } from "../../../../../utils/asyncForm";
import { styles } from "../../../index";
import {
  StatementType,
  StatementTypeNoPt3,
  StatementTypeSenatorAndOthers,
  StatementTypeSenatorAndOthersWithPoint3,
  StatementTypeSenatorOnly,
  StatementTypeSenatorNoPoint3,
  StatementTypeSenatorWithPoint3,
  StatementTypeDeputy,
  StatementTypeDeputyOld,
  StatementTypeDeputySenatorAndOthers,
  StatementTypeRaw,
  StatementStateRaw,
  StatementFileType,
  Visibility
} from "../../../enum";
import {
  isOfficial,
  isInternal,
  isNotLogged,
  isPublic,
  oneOf,
  isOfficialAdmin,
  copySubstatement,
  isLogged,
  isAdmin,
} from "../../../CroUtils";
import WorkingPositions from "./FieldArrayComponents/WorkingPositions";
import Bussiness from "./FieldArrayComponents/Bussiness";
import Associates from "./FieldArrayComponents/Associates";
import OrganizationMember from "./FieldArrayComponents/OrganizationMember";
import Media from "./FieldArrayComponents/Media";
import OtherContracts from "./FieldArrayComponents/OtherContracts";
import Realties from "./FieldArrayComponents/Realties";
import CommercialPapers from "./FieldArrayComponents/CommercialPapers";
import CorporationShares from "./FieldArrayComponents/CorporationShares";
import Chattels from "./FieldArrayComponents/Chattels";
import Incomes from "./FieldArrayComponents/Incomes";
import Liabilities from "./FieldArrayComponents/Liabilities";
import * as V from "../../../../../utils/formValidation";
import {
  isEmpty,
  isUndefined,
  get,
  split,
  isNil,
  isArray,
  isObject,
} from "lodash";
import { convert, addressToForm } from "../../../converts";
import H from "../../../helpEnum";
import { getCzechRepublic, getAresData } from "../../../CroActions";
import {setLoading, togglePanel} from "../../../../../actions/appActions";
import { v4 as uuid } from "uuid";
import CroFiles from "../../generalForm/CroFiles";
import moment from "moment";
import { isFormTouched } from "../../../../../utils/isFormTouched";
import InfoMessage from "../../InfoMessage";
import { FormattedDate, FormattedTime } from "react-intl";
import CroLabeledCmp from "../../generalForm/CroLabeledCmp";
import { InspectionStatementsGrid } from "../../grids/InspectionGrid";

const t = (type, promisedDos) => {
  const TypeM = {
    [StatementTypeRaw.INGOING]: "IN_",
    [StatementTypeRaw.ONGOING]: "ON_",
    [StatementTypeRaw.OUTGOING]: "OUT_",
    [StatementTypeRaw.POINT3]: "POINT3_",
    [StatementTypeRaw.POINT4]: "POINT4_",
    [StatementTypeRaw.DEPUTYORSENATE]: "OFFICIAL_",
  };
  const result = promisedDos ? "OFFICIAL_" : TypeM[type];
  return isUndefined(result) ? "IN_" : result;
};

const minLength5 = V.minLength(5);

const FORM_NAME = "statementForm";
class StatementForm extends Component {
  state = {
    defaultCountry: undefined,
    isFormTouched: false,
    official: null,
    aresErrors: { business: {}, associates: {}, orgMember: {}, corpShares: {}, corpSharesBefore: {}, media: {}, otherContracts: {}, incomes: {}, liabilities: {} }
  };
  realties = { old: null, new: null };

  setDataNewStatement = (official) => {
    const { change } = this.props;
    change(
        "official",
        convert(official, {
          birthAddress: addressToForm,
          deliveryAddress: addressToForm,
        }),
    );
    change("official.deputyOrSenator", official.deputyOrSenator);
    change("official.promiseDocumented", official.promiseDocumented);
    change(
        "statementOfficial",
        convert(official, {
          birthAddress: addressToForm,
          deliveryAddress: addressToForm,
        }),
    );
    change("statementOfficial.id", uuid());
    //change('workingPositions', this.initWPs([this.props.workingPositionsAll[0]]));
    //change('workingPositions', []);
    change("officialWorkingPositions", []);
  };

  filterAwps = (type, wps) => {
    const wpIds = wps.map((wp) => wp.id);
    return isEmpty(wps)
        ? this.autocompleteWps.filter((awpom) => awpom.type === type)
        : this.autocompleteWps.filter(
            (awpom) => awpom.type === type && wpIds.includes(awpom.wp.id),
        );
  };

  autofillFromToAndWPs = (awp, change, wps = []) => {
    if (awp.type === StatementTypeRaw.ONGOING) {
      //gruping
      const pomAwps = this.filterAwps(StatementTypeRaw.ONGOING, wps);

      if (isEmpty(pomAwps)) {
        change("fromDate", null);
        change("toDate", null);
        change("officialWorkingPositions", wps);
        this.performValidation();
      } else {
        const minStart = moment.min(pomAwps.map((awpom) => moment(awpom.from)));
        const maxEnd = moment.max(pomAwps.map((awpom) => moment(awpom.to)));

        change("fromDate", minStart.format("YYYY-MM-DD"));
        change("toDate", maxEnd.format("YYYY-MM-DD"));
        change(
            "officialWorkingPositions",
            isEmpty(wps) ? pomAwps.map((awpom) => awpom.wp) : wps,
        );
      }
    } else {
      change("fromDate", awp.from);
      change("toDate", awp.to);
      change("officialWorkingPositions", [awp.wp]);
    }
  };

  onOpenInspection = (inspection) => {
    const { auth, params } = this.props;
    this.props.dispatch(push(`${auth.startUrl}/funkcionari/${params.id}/kontroly/${inspection.id}`));
  };

  async componentWillMount() {
    const {
      breadcrumbs,
      breadcrumbsItems,
      auth,
      getMe,
      getOfficial,
      params,
      dispatch,
      isNew,
      change,
      statementOfficial
    } = this.props;

    breadcrumbs(breadcrumbsItems);
    if (isOfficial(auth) && getMe instanceof Function) {
      dispatch(setLoading(true, "Načítání dat..."));
      const official = await getMe(dispatch);
      this.autocompleteWps = official.autocompleteWps;
      this.setState({ official });
      isNew
          ? this.setDataNewStatement(official)
          : change("official.hasPoint3", official.hasPoint3);
      dispatch(setLoading());
    }
    if (isOfficialAdmin(auth) && getOfficial instanceof Function) {
      dispatch(setLoading(true, "Načítání dat..."));
      const official = await getOfficial(params.id, dispatch);
      this.autocompleteWps = official.autocompleteWps;
      isNew
          ? this.setDataNewStatement(official)
          : change("official.hasPoint3", official.hasPoint3);
      dispatch(setLoading());
    }

    if (isNew && !isEmpty(this.autocompleteWps)) {
      const awp = this.autocompleteWps[0];
      change("type", awp.type);
      this.autofillFromToAndWPs(awp, change);
    }

    getCzechRepublic(dispatch).then((result) => {
      if (isNew) {
        change("statementOfficial.deliveryAddress.country", result);
      }
      this.setState({ ...this.state, defaultCountry: result });
    });

    // if(this.props.params.id) {
    //     await fetch(`/funkcionar/api/oznameni/log/open/${this.props.params.id}`, {
    //       method: 'POST',
    //       headers: new Headers({ 'Content-Type': 'application/json' })
    //     });
    //   }
  }

  async componentDidUpdate(prevProps) {
    const {
      fullyLoaded,
      isNew,
      type,
      workingPositions,
      workingPositionsAll,
      change,
      type_senator,
      senator,
      senatorAndOthers,
      getMe,
      dispatch,
      cloneStatement
    } = this.props;

    this.cloned = cloneStatement;

    if (cloneStatement && fullyLoaded !== prevProps.fullyLoaded) {
      const official = await getMe(dispatch);
      this.autocompleteWps = official.autocompleteWps;
      this.cloneStatement();
    }

    if (fullyLoaded !== prevProps.fullyLoaded) {
      this.originalType = type;
    }

    if (fullyLoaded) {
      // load all working positions when point3 is selected
      if (
          isNew &&
          type === StatementTypeRaw.POINT3 &&
          prevProps.type !== StatementTypeRaw.POINT3
      ) {
        //change('workingPositions', this.initWPs(workingPositionsAll));
        change("officialWorkingPositions", this.initWPs(workingPositionsAll));
      }

      // clear all working positions when
      //  - form is loaded from template
      //  - original form is point4 or ongoing
      //  - ingoing or outgoing statement is selected
      //  - original form has more than one WPs
      if (
          cloneStatement &&
          (type === StatementTypeRaw.INGOING ||
              type === StatementTypeRaw.OUTGOING) &&
          (prevProps.type === StatementTypeRaw.POINT4 ||
              prevProps.type === StatementTypeRaw.ONGOING) &&
          workingPositions.length > 1
      ) {
        //change('workingPositions', []);
        change("officialWorkingPositions", []);
      }

      // set statements for senators/promised-senators -andOthers
      if (
          (senator || senatorAndOthers) &&
          type_senator !== prevProps.type_senator
      ) {
        const typeValues = split(type_senator, "_");

        change("type", typeValues[0]);
        if (typeValues.length > 1 && typeValues[1] === "PROMISED") {
          change("senator", true);
        } else {
          change("senator", false);
        }
      }

      if (
          type === StatementTypeRaw.INGOING &&
          ([
                StatementTypeRaw.POINT3,
                StatementTypeRaw.OUTGOING,
                StatementTypeRaw.ONGOING,
              ].indexOf(prevProps.type) > -1 ||
              (prevProps.type === null &&
                  this.originalType !== StatementTypeRaw.INGOING))
      ) {
        const {
          change,
          realties,
          realtiesEnabled,
          commercialPapers,
          commercialPapersEnabled,
          corporationShares,
          corporationSharesEnabled,
          chattels,
          chattelsEnabled,
          fromDate,
        } = this.props;

        //workingPositionDate
        change("workingPositionDate", fromDate);

        //realties
        copySubstatement(
            "realtiesBefore",
            cloneStatement && this.realties.new !== null ? this.realties.new : realties,
            "realties",
            "realtiesBeforeEnabled",
            realtiesEnabled,
            "realtiesEnabled",
            change,
        );
        //commercialPapers
        copySubstatement(
            "commercialPapersBefore",
            commercialPapers,
            "commercialPapers",
            "commercialPapersBeforeEnabled",
            commercialPapersEnabled,
            "commercialPapersEnabled",
            change,
        );
        //corporationShares
        copySubstatement(
            "corporationSharesBefore",
            corporationShares,
            "corporationShares",
            "corporationSharesBeforeEnabled",
            corporationSharesEnabled,
            "corporationSharesEnabled",
            change,
        );
        //chattels
        copySubstatement(
            "chattelsBefore",
            chattels,
            "chattels",
            "chattelsBeforeEnabled",
            chattelsEnabled,
            "chattelsEnabled",
            change,
        );
      }

      if (
          [
            StatementTypeRaw.POINT3,
            StatementTypeRaw.OUTGOING,
            StatementTypeRaw.ONGOING,
          ].indexOf(type) > -1 &&
          (prevProps.type === StatementTypeRaw.INGOING ||
              (prevProps.type === null &&
                  this.originalType === StatementTypeRaw.INGOING))
      ) {
        const {
          change,
          realtiesBefore,
          realtiesBeforeEnabled,
          commercialPapersBefore,
          commercialPapersBeforeEnabled,
          corporationSharesBefore,
          corporationSharesBeforeEnabled,
          chattelsBefore,
          chattelsBeforeEnabled,
          toDate,
        } = this.props;

        //workingPositionDate
        change("workingPositionDate", toDate);

        //realties
        copySubstatement(
            "realties",
            cloneStatement && this.realties.old !== null
                ? this.realties.old
                : realtiesBefore,
            "realtiesBefore",
            "realtiesEnabled",
            realtiesBeforeEnabled,
            "realtiesBeforeEnabled",
            change,
        );
        //commercialPapers
        copySubstatement(
            "commercialPapers",
            commercialPapersBefore,
            "commercialPapersBefore",
            "commercialPapersEnabled",
            commercialPapersBeforeEnabled,
            "commercialPapersBeforeEnabled",
            change,
        );
        //corporationShares
        copySubstatement(
            "corporationShares",
            corporationSharesBefore,
            "corporationSharesBefore",
            "corporationSharesEnabled",
            corporationSharesBeforeEnabled,
            "corporationSharesBeforeEnabled",
            change,
        );
        //chattels
        copySubstatement(
            "chattels",
            chattelsBefore,
            "chattelsBefore",
            "chattelsEnabled",
            chattelsBeforeEnabled,
            "chattelsBeforeEnabled",
            change,
        );
      }

      //remove toDate when type of statement is INGOING, POINT3, POINT4
      if (
          [StatementTypeRaw.POINT3, StatementTypeRaw.INGOING].indexOf(type) >
          -1 &&
          [
            StatementTypeRaw.OUTGOING,
            StatementTypeRaw.ONGOING,
            StatementTypeRaw.POINT4,
          ].indexOf(prevProps.type) > -1
      ) {
        change("toDate", "");
      }

      const singleEntryTypes = [
        StatementTypeRaw.INGOING,
        StatementTypeRaw.OUTGOING,
        StatementTypeRaw.DEPUTYORSENATE,
      ];
      if (
          singleEntryTypes.includes(type) &&
          type !== prevProps.type &&
          workingPositions &&
          workingPositions.length > 1
      ) {
        change("officialWorkingPositions", workingPositions.slice(0, 1));
      }

      if (!isEmpty(this.autocompleteWps)) {
        const wpsChanged =
            !isNil(workingPositions) &&
            !isNil(prevProps.workingPositions) &&
            ((!isEmpty(workingPositions) &&
                    workingPositions.length !== prevProps.workingPositions.length) ||
                (!isEmpty(workingPositions) &&
                    !isEmpty(prevProps.workingPositions) &&
                    workingPositions[workingPositions.length - 1].id !==
                    prevProps.workingPositions[
                    prevProps.workingPositions.length - 1
                        ].id));

        if (!isNil(type) && (type !== prevProps.type || wpsChanged)) {
          const awps = this.filterAwps(
              type,
              wpsChanged ? workingPositions : [],
          );
          if (!isEmpty(awps)) {
            this.autofillFromToAndWPs(
                awps[0],
                change,
                wpsChanged ? workingPositions : [],
            );
          } else {
            //clear from,to
            change("fromDate", null);
            change("toDate", null);
            this.performValidation();
          }
        }
      }
    }
  }

  changeArray = (what) => (oldVal, val) => {
    if (val === true && oldVal !== val) {
      this.props.array.push(what, { itemOrder: 1 });
    } else if (oldVal !== val) {
      this.props.array.removeAll(what);
    }
    this.props.touch(`${what}Enabled`);
  };

  changeWPDate = (e, newValue) => {
    this.props.change("workingPositionDate", newValue);
  };

  onSourceCheck = (field, value) => () => {
    this.props.change(field, value);
  };

  initWPs = (wps) => {
    if (isEmpty(wps)) {
      return [];
    }

    let initWps = [];
    wps.map((wp) => {
      // return initWps.push({ organization: wp.organization, workingPosition: wp.workingPosition });
      return initWps.push(wp);
    });
    return initWps;
  };

  changeIds = (arrayOfSubStatements) => {
    const recursivelyChangeIds = (obj) => {
      if (!isNil(obj.id)) {
        obj.id = uuid();
      }
      Object.keys(obj)
          .filter(
              (key) =>
                  isObject(obj[key]) &&
                  !key.includes("municipality") &&
                  isNil(obj[key].active),
          )
          .forEach((key) => recursivelyChangeIds(obj[key]));
    };

    arrayOfSubStatements.forEach((subStatement) =>
        recursivelyChangeIds(subStatement),
    );
  };

  changeRealties = (realties) => {
    if (isArray(realties) && this.realties.old === null) {
      const uniqRealties = [
        ...new Map(
            realties
                .filter((realty) => !isNil(realty.lv) && !isNil(realty.cadastre))
                .map((realty) => [`${realty.lv}${realty.cadastre.code}`, realty]),
        ).values(),
      ];

      this.realties.old = realties;
      this.realties.new = uniqRealties;
    }
  };

  setAresError = (section, index, error) => {
    this.setState((prevState) => ({
      aresErrors: {
        ...prevState.aresErrors,
        [section]: {
          ...prevState.aresErrors[section],
          [index]: error,
        },
      },
    }));
  };

  aresFieldPrefixes = (section, index) => {
    let addressPrefix;
    let namePrefix;

    if (section === "business") {
      addressPrefix = `naturalPersonBusinesses[${index}].address`;
      namePrefix = null;
    } else if (section === "associates") {
      addressPrefix = `legalBusinessAssociates[${index}].legalPerson.address`;
      namePrefix = `legalBusinessAssociates[${index}].legalPerson.name`;
    } else if (section === "orgMember") {
      addressPrefix = `organizationMember[${index}].legalPerson.address`;
      namePrefix = `organizationMember[${index}].legalPerson.name`;
    } else if (section === "corpShares") {
      addressPrefix = `corporationShares[${index}].address`;
      namePrefix = `corporationShares[${index}].name`;
    } else if (section === "corpSharesBefore") {
      addressPrefix = `corporationSharesBefore[${index}].address`;
      namePrefix = `corporationSharesBefore[${index}].name`;
    } else if (section === "media") {
      addressPrefix = `media[${index}].legalPerson.address`;
      namePrefix = `media[${index}].legalPerson.name`;
    } else if (section === "otherContracts") {
      addressPrefix = `otherContracts[${index}].address`;
      namePrefix = `otherContracts[${index}].name`;
    } else if (section === "incomes") {
      addressPrefix = `incomes[${index}].legalPerson.address`;
      namePrefix = `incomes[${index}].legalPerson.name`;
    } else if (section === "liabilities") {
      addressPrefix = `liabilities[${index}].legalPerson.address`;
      namePrefix = `liabilities[${index}].legalPerson.name`;
    }

    return { addressPrefix, namePrefix };
  };

  clearAresAddress = (section, index) => {
    const { change } = this.props;
    const { addressPrefix } = this.aresFieldPrefixes(section, index);

    if (!addressPrefix) return;

    change(`${addressPrefix}.municipality`, "");
    change(`${addressPrefix}.street`, "");
    change(`${addressPrefix}.orientationNumber`, "");
    change(`${addressPrefix}.zip`, "");
  };

  clearAresFields = (section, index) => {
    const { change } = this.props;
    const { namePrefix } = this.aresFieldPrefixes(section, index);

    if (namePrefix) change(namePrefix, "");
    this.clearAresAddress(section, index);
  };

  /**
   * @param preserveManualData při použití jako šablona se ručně vyplněné údaje
   * nesmí smazat, když ARES data nevrátí (neexistující nebo zahraniční IČO).
   */
  handleIcoLookup = async (section, index, ico, preserveManualData = false) => {
    const { change } = this.props;

    if (!ico) {
      this.setAresError(section, index, null);
      return;
    }

    const result = await getAresData(ico);

    if (result && result.error) {
      if (preserveManualData) {
        // Ponecháme původní ručně zadané údaje i chybné IČO beze změny
        this.setAresError(section, index, null);
        return;
      }

      const errorMsg =
        result.error === "notFound"
          ? "Subjekt s tímto IČO nebyl nalezen v ARES."
          : "Nepodařilo se načíst data z ARES. Zkontrolujte zadávaný údaj a zkuste to prosím znovu.";
      this.setAresError(section, index, errorMsg);
      this.clearAresFields(section, index);
      return;
    }

    this.setAresError(section, index, null);

    const { addressPrefix, namePrefix } = this.aresFieldPrefixes(section, index);

    if (namePrefix && result.name) {
      change(namePrefix, result.name);
    }

    if (result.address) {
      const addr = result.address;
      if (addr.country) change(`${addressPrefix}.country`, addr.country);
      change(`${addressPrefix}.municipality`, addr.municipalityId ? { id: addr.municipalityId, fullName: addr.municipality } : addr.municipality || "");
      change(`${addressPrefix}.street`, addr.street || "");
      change(`${addressPrefix}.orientationNumber`, addr.orientationNumber || "");
      change(`${addressPrefix}.zip`, addr.zip || "");
    } else if (!preserveManualData) {
      // Subjekt nalezen, ale bez adresy – nesmí zůstat adresa předchozího IČO
      this.clearAresAddress(section, index);
    }
  };

  cloneStatement = () => {
    const { change, breadcrumbs, statementOfficial, invalidFields } = this.props;
    const {
      realties,
      realtiesBefore,
      commercialPapers,
      commercialPapersBefore,
      corporationShares,
      corporationSharesBefore,
      chattels,
      chattelsBefore,
      incomes,
      associates,
      business,
      liabilities,
      media,
      organizationMember,
      otherContracts,
      type,
      workingPositionsAll
    } = this.props;

    breadcrumbs([{ label: "Oznámení" }, { label: "Nové oznámení" }]);
    change("id", uuid());
    change("statementOfficial.id", uuid());
    change("statementOfficial.birthAddress.id", uuid());
    change("statementOfficial.deliveryAddress.id", uuid());
    if (!get(statementOfficial, "deliveryAddress.municipality.id", false))
      change("statementOfficial.deliveryAddress.municipality", "");
    change("state", StatementStateRaw.NEW);
    //change('workingPositions', this.initWPs(workingPositions));
    // change('type', null);                   //  ZAKOMENTOVAT ked budu nastavovat sablonu
    change("type_senator", null); // #002359 nullovat pri pouziti sablony
    // change('fromDate', null);               //  ZAKOMENTOVAT
    // change('toDate', null);                 //  ZAKOMENTOVAT
    // change('officialWorkingPositions', []); //  ZAKOMENTOVAT
    //change('workingPositions', []);
    change("created", "");
    change("updated", "");
    change("lastModified", "");
    change("creationDate", "");

    // Always regenerate IDs for all child entities to prevent sharing rows with the template
    if (!isEmpty(business)) this.changeIds(business);
    if (!isEmpty(associates)) this.changeIds(associates);
    if (!isEmpty(organizationMember)) this.changeIds(organizationMember);
    if (!isEmpty(media)) this.changeIds(media);
    if (!isEmpty(realties)) {
      this.changeIds(realties);
      this.changeRealties(realties);
    }
    if (!isEmpty(realtiesBefore)) {
      this.changeIds(realtiesBefore);
      this.changeRealties(realtiesBefore);
    }
    if (!isEmpty(commercialPapers)) this.changeIds(commercialPapers);
    if (!isEmpty(commercialPapersBefore))
      this.changeIds(commercialPapersBefore);
    if (!isEmpty(corporationShares)) this.changeIds(corporationShares);
    if (!isEmpty(corporationSharesBefore))
      this.changeIds(corporationSharesBefore);
    if (!isEmpty(chattels)) this.changeIds(chattels);
    if (!isEmpty(chattelsBefore)) this.changeIds(chattelsBefore);
    if (!isEmpty(incomes)) this.changeIds(incomes);
    if (!isEmpty(liabilities)) this.changeIds(liabilities);
    if (!isEmpty(otherContracts)) this.changeIds(otherContracts);

    // Refresh ARES data for all ICO fields when using as template
    if (!isEmpty(business)) {
      business.forEach((item, i) => {
        const ico = get(item, "identificationNumber");
        if (ico) this.handleIcoLookup("business", i, ico, true);
      });
    }
    if (!isEmpty(associates)) {
      associates.forEach((item, i) => {
        const ico = get(item, "legalPerson.identificationNumber");
        if (ico) this.handleIcoLookup("associates", i, ico, true);
      });
    }
    if (!isEmpty(organizationMember)) {
      organizationMember.forEach((item, i) => {
        const ico = get(item, "legalPerson.identificationNumber");
        if (ico) this.handleIcoLookup("orgMember", i, ico, true);
      });
    }
    if (!isEmpty(corporationShares)) {
      corporationShares.forEach((item, i) => {
        const ico = get(item, "identificationNumber");
        if (ico) this.handleIcoLookup("corpShares", i, ico, true);
      });
    }
    if (!isEmpty(corporationSharesBefore)) {
      corporationSharesBefore.forEach((item, i) => {
        const ico = get(item, "identificationNumber");
        if (ico) this.handleIcoLookup("corpSharesBefore", i, ico, true);
      });
    }
    if (!isEmpty(media)) {
      media.forEach((item, i) => {
        const ico = get(item, "legalPerson.identificationNumber");
        if (ico) this.handleIcoLookup("media", i, ico, true);
      });
    }
    if (!isEmpty(otherContracts)) {
      otherContracts.forEach((item, i) => {
        const ico = get(item, "identificationNumber");
        if (ico) this.handleIcoLookup("otherContracts", i, ico, true);
      });
    }
    if (!isEmpty(incomes)) {
      incomes.forEach((item, i) => {
        const ico = get(item, "legalPerson.identificationNumber");
        if (ico) this.handleIcoLookup("incomes", i, ico, true);
      });
    }
    if (!isEmpty(liabilities)) {
      liabilities.forEach((item, i) => {
        const ico = get(item, "legalPerson.identificationNumber");
        if (ico) this.handleIcoLookup("liabilities", i, ico, true);
      });
    }

    // const autocompleteWps = official.autocompleteWps;
    const awps = this.filterAwps(type, workingPositionsAll); // TOTO VYFILTRUJE PRUNIK autocompleteWps && workpositions
    const arrayWpFromAwps = awps.map((awp) => awp.wp);

    // check if awps is empty
    if (isEmpty(awps)) {
      change("fromDate", null);
      change("toDate", null);
      change("officialWorkingPositions", []);
    } else {
      this.autofillFromToAndWPs(awps[0], change, arrayWpFromAwps);
    }

    // this.autofillFromToAndWPs(awps[0], change, arrayWpFromAwps)

    // Invalid fields? Perform validations and mark them as touched to show errors
    if (Object.keys(invalidFields || {}).length > 0) {
      this.performValidation();
      this.toggleInvalidFieldsInfo();
    }
  };

  oldSenator = (wps) => {
    if (!isNil(wps)) {
      return wps.some((wp) => {
        return (
            new Date(wp.start) < new Date(2017, 8, 1) &&
            wp.workingPosition.name.toLowerCase().includes("senátor")
        );
      });
    }
    return false;
  };

  onlyOldSenator = (wps) => {
    if (!isNil(wps)) {
      return wps.every((wp) => {
        return (
            new Date(wp.start) < new Date(2017, 8, 1) &&
            wp.workingPosition.name.toLowerCase().includes("senátor")
        );
      });
    }
    return false;
  };

  filteredStmtTypes = (types) => {
    return types;
  };

  goBack = () => {
    this.props.router.goBack();
  };

  performValidation = () => {
    this.props.handleSubmit(() => {})();
  }

  toggleInvalidFieldsInfo = () => {
    this.props.dispatch(togglePanel("Zkontrolujte správnost polí, která jsou zvýrazněna červeně"));
  }

  saveStatement = () => {
    const { getAllData, onSubmit, invalidFields } = this.props;
    if (this.hasFormNonRequiredFieldErrors(invalidFields)) {
      this.toggleInvalidFieldsInfo();
      this.performValidation();
      return;
    }

    let data = getAllData();

    if (isEmpty(get(data, "officialWorkingPositions[0]"))) {
      data.officialWorkingPositions = [];
    }

    onSubmit(data);
  };

  exportStatementToPdf = () => {
    const { getAllData, exportPdf, invalidFields, auth } = this.props;
    if ((!isOfficialAdmin(auth) && !isAdmin(auth)) && this.hasFormNonRequiredFieldErrors(invalidFields)) {
      this.toggleInvalidFieldsInfo();
      this.performValidation();
      return;
    }

    let data = getAllData();
    exportPdf(data);
  }

  exportStatementToPdfPublic = () => {
    const { getAllData, exportPdfPublic, invalidFields, auth } = this.props;
    if ((!isOfficialAdmin(auth) && !isAdmin(auth)) && this.hasFormNonRequiredFieldErrors(invalidFields)) {
      return;
    }

    let data = getAllData();
    exportPdfPublic(data);
  }

  exportStatementToPdfRequest = () => {
    const { getAllData, exportPdfRequest, invalidFields, auth } = this.props;
    if ((!isOfficialAdmin(auth) && !isAdmin(auth)) && this.hasFormNonRequiredFieldErrors(invalidFields)) {
      this.toggleInvalidFieldsInfo();
      this.performValidation();
      return;
    }

    let data = getAllData();
    exportPdfRequest(data);
  }

  //= sectionEnabled
  se = (bool) => {
    const { disabled, auth } = this.props;
    return !disabled || !isNil(bool) || isInternal(auth);
  };

  hadndleIsFormTouch = () => {
    let formTouch;
    if (this.cloned) {
      formTouch = isFormTouched(this.props.dispatch, false, true);
    } else {
      formTouch = isFormTouched(
          this.props.dispatch,
          this.props.params.id,
          false,
      );
    }
    if (formTouch) {
      this.setState({ ...this.state, isFormTouched: true });
    }
  };

  changeWPDateAndIsFormTouch = (e, newValue) => {
    this.props.change("workingPositionDate", newValue);

    if (isOfficial(this.props.auth) && !this.state.isFormTouched) {
      let formTouch;
      if (this.cloned) {
        formTouch = isFormTouched(this.props.dispatch, false, true);
      } else {
        formTouch = isFormTouched(
            this.props.dispatch,
            this.props.params.id,
            false,
        );
      }
      if (formTouch) {
        this.setState({ ...this.state, isFormTouched: true });
      }
    }
  };

  getFormFieldErrorTypes = (errors, result = {}) => {
    if (!errors) return result;

    const errorTypes = {
      "Povinné pole": "required",
    }

    if (typeof errors === 'string') {
      const errorKey = errorTypes[errors] ? errorTypes[errors] : errors;
      result[errorKey] = (result[errorKey] || 0) + 1;
    } else if (Array.isArray(errors)) {
      errors.forEach(item => this.getFormFieldErrorTypes(item, result));
    } else if (typeof errors === 'object') {
      Object.values(errors).forEach(val => this.getFormFieldErrorTypes(val, result));
    }

    return result;
  }

  hasFormNonRequiredFieldErrors = (invalidFields) => {
    const formErrorTypes = this.getFormFieldErrorTypes(invalidFields);
    return Object.keys(formErrorTypes).some(key => key !== "required");
  }

  render() {
    const {
      error,
      onSubmit,
      handleSubmit,
      submitting,
      type,
      state,
      auth,
      onSend,
      onIncomplete,
      dispatch,
      isPublicStatement,
      cloneStatement,
      readOnly,
      invalidFields,
      fullyLoaded,
      params
    } = this.props;
    const {
      workingPositions,
      promiseDocumented,
      officialId,
      submitFailed,
      disabled,
      workingPositionsAll,
      change,
    } = this.props;

    const {
      naturalPersonBusinessesEnabled,
      commercialPapersEnabled,
      commercialPapersBeforeEnabled,
      corporationSharesEnabled,
      corporationSharesBeforeEnabled,
      chattelsEnabled,
      chattelsBeforeEnabled,
      incomesEnabled,
      organizationMemberEnabled,
      otherContractsEnabled,
      legalBusinessAssociatesEnabled,
      realtiesEnabled,
      realtiesBeforeEnabled,
      liabilitiesEnabled,
      mediaEnabled,
      deputy,
      deputyAndOthers,
      senator,
      senatorAndOthers,
      hasFileRef,
      dosStatement,
      hasPoint3,
      lastModified,
      isNew,
      isCity,
      isVillage,
      isReleased,
      creationDate,
      versionValidTo,
      prevVersion,
      versionDiff,
      useAsTemplateDisabled
    } = this.props;

    const invalidFormFields = this.hasFormNonRequiredFieldErrors(invalidFields);
    const { defaultCountry, aresErrors } = this.state;
    const generalInfoDisabled = (isOfficial(auth) || disabled);

    const ingoing = type === StatementTypeRaw.INGOING;
    const ongoing = type === StatementTypeRaw.ONGOING;
    const outgoing = type === StatementTypeRaw.OUTGOING;
    const point3 = type === StatementTypeRaw.POINT3;
    const point4 = type === StatementTypeRaw.POINT4;
    const deputyStatement = type === StatementTypeRaw.DEPUTYORSENATE;

    const oldSenator = this.oldSenator(workingPositionsAll);
    const onlyOldSenator = this.onlyOldSenator(workingPositionsAll);

    const promisedDos =
        (senator || senatorAndOthers) && oldSenator && dosStatement;

    const noPublicLogged = !(isNotLogged(auth) || isPublic(auth));

    const isNewState =
        state == null ||
        state === StatementStateRaw.NEW ||
        state === StatementStateRaw.INCOMPLETE;

    const getVersionChangedClass = (fieldKey) => {
      if (!versionDiff) return "";
      return versionDiff[fieldKey] ? `statementForm__versionChange ${versionDiff[fieldKey]}` : (versionDiff[fieldKey + '.id'] ? `statementForm__versionChange ${versionDiff[fieldKey + '.id']}` : "");
    }

    const inspectionsUrl = `${auth.startUrl}/api/funkcionari/${params.id}/oznameni/${params.statement_id}/kontroly`;

    return (
        <form
            onSubmit={handleSubmit(onSubmit)}
            className="statement cro-form statementForm"
            onChange={() =>
                isOfficial(auth)
                    ? !this.state.isFormTouched && this.hadndleIsFormTouch()
                    : () => void 0
            }
        >
          {versionValidTo && (
            <div className="statementForm__heading"> 
              Verze oznámení platná do <FormattedDate value={versionValidTo} /> <FormattedTime value={versionValidTo} />
              <div className="statementForm__versionChangeInfo">
                Úpravy v oznámení jsou oproti předchozí verzi zvýrazněny rámečkem: červeně odstraněné, zeleně přidané, černě změněné.
              </div>
            </div>
          )}
          {!versionValidTo && prevVersion && (
            <div className="statementForm__heading">
              Aktuálně platná verze oznámení
              <div className="statementForm__versionChangeInfo">
                Úpravy v oznámení jsou oproti předchozí verzi zvýrazněny rámečkem: červeně odstraněné, zeleně přidané, černě změněné.
              </div>
            </div>
          )}

          {/* === Všeobecné údaje === */}
          <div className="statementForm__section">
            <CroSubhead title="Všeobecné údaje" />

            <div className="cro-form in">
              <CroField
                  className={`third ${getVersionChangedClass('statementOfficial.titleBefore')}`}
                  title="Titul před"
                  name="statementOfficial.titleBefore"
                  component={Input}
                  disabled={generalInfoDisabled}
              />
              <CroField
                  className={`third ${getVersionChangedClass('statementOfficial.firstName')}`}
                  title="Jméno"
                  name="statementOfficial.firstName"
                  component={Input}
                  disabled={generalInfoDisabled}
                  validate={[V.required, V.textSpaceDashOnly, V.noSpaceStartEnd]}
              />
              <CroField
                  className={`third ${getVersionChangedClass('statementOfficial.middleName')}`}
                  title="Další jména"
                  name="statementOfficial.middleName"
                  component={Input}
                  disabled={generalInfoDisabled}
              />

              <CroField
                  className={`third ${getVersionChangedClass('statementOfficial.lastName')}`}
                  title="Příjmení"
                  name="statementOfficial.lastName"
                  component={Input}
                  disabled={generalInfoDisabled}
                  validate={[V.required, V.textSpaceDashOnly, V.noSpaceStartEnd]}
              />
              <CroField
                  className={`third ${getVersionChangedClass('statementOfficial.titleAfter')}`}
                  title="Titul za"
                  name="statementOfficial.titleAfter"
                  component={Input}
                  disabled={generalInfoDisabled}
              />
              {noPublicLogged && (
                  <CroField
                      className={`third ${getVersionChangedClass('statementOfficial.idCardNumber')}`}
                      title="Číslo OP"
                      name="statementOfficial.idCardNumber"
                      component={Input}
                      disabled={disabled || (generalInfoDisabled && !isOfficial(auth))}
                      validate={[minLength5]}
                  />
              )}
            </div>
          </div>

          {/* === Datum narození === */}
          {noPublicLogged && (
              <div className="statementForm__section">
                <CroSubhead title="Údaje o narození" />
                <div className="statementForm__arrayGrid statementForm__arrayGrid--3col">
                  <CroField
                      className={getVersionChangedClass('statementOfficial.birthDate')}
                      title="Datum narození"
                      name="statementOfficial.birthDate"
                      component={DatePicker}
                      noIcon
                      disabled={disabled || generalInfoDisabled}
                      validate={[V.required, V.beforeToday]}
                  />
                  <CroCountry
                      className={getVersionChangedClass('statementOfficial.birthAddress.country')}
                      title="Stát narození"
                      name="statementOfficial.birthAddress"
                      disabled={disabled || generalInfoDisabled}
                      form={FORM_NAME}
                      validate={[V.required]}
                      helpEnum={H[`${t(type, promisedDos)}BIRTH_COUNRTY`].r}
                  />
                  <CroMunicipality
                      className={getVersionChangedClass('statementOfficial.birthAddress.municipality')}
                      title="Obec narození"
                      name="statementOfficial.birthAddress"
                      disabled={disabled || generalInfoDisabled}
                      form={FORM_NAME}
                      validate={[V.required]}
                      helpEnum={H[`${t(type, promisedDos)}BIRTH_MUNICIPALITY`].r}
                  />
                </div>
              </div>
          )}

          {/* === Adresa pro doručování === */}
          {noPublicLogged && (
              <div className="statementForm__section">
                <CroSubhead title="Adresa pro doručování" />
                <div className="statementForm__arrayGrid">
                  <CroField
                      className={getVersionChangedClass('statementOfficial.databox')}
                      title="Datová schránka"
                      name="statementOfficial.databox"
                      component={Input}
                      disabled={disabled}
                  />
                  <CroField
                      className={getVersionChangedClass('statementOfficial.email')}
                      title="E-mail"
                      name="statementOfficial.email"
                      component={Input}
                      disabled={disabled}
                      validate={[V.email]}
                      helpEnum={H[`${t(type, promisedDos)}EMAIL`].r}
                      hintText="@"
                  />
                  <CroCountry
                      className={getVersionChangedClass('statementOfficial.deliveryAddress.country')}
                      title="Stát"
                      name="statementOfficial.deliveryAddress"
                      disabled={disabled}
                      form={FORM_NAME}
                  />
                  <CroMunicipality
                      className={getVersionChangedClass('statementOfficial.deliveryAddress.municipality')}
                      title="Obec"
                      name="statementOfficial.deliveryAddress"
                      disabled={disabled}
                      form={FORM_NAME}
                  />
                  <CroField
                      className={getVersionChangedClass('statementOfficial.deliveryAddress.street')}
                      title="Ulice"
                      name="statementOfficial.deliveryAddress.street"
                      component={Input}
                      disabled={disabled}
                  />
                  <CroField
                      className={getVersionChangedClass('statementOfficial.deliveryAddress.orientationNumber')}
                      title="Č.p./Č.o."
                      name="statementOfficial.deliveryAddress.orientationNumber"
                      component={Input}
                      disabled={disabled}
                      helpEnum={H.HOUSE_NUMBER.r}
                  />
                  <CroField
                      className={getVersionChangedClass('statementOfficial.deliveryAddress.zip')}
                      title="PSČ"
                      name="statementOfficial.deliveryAddress.zip"
                      component={Input}
                      disabled={disabled}
                  />
                </div>

                <p style={{ margin: "14px 0 6px", color: "#6b7280", fontSize: 13 }}>
                  Výše uvedené údaje slouží výhradně pro komunikaci evidenčního
                  orgánu s veřejným funkcionářem a nebudou zveřejněny při nahlížení
                  do Centrálního registru oznámení veřejností.
                </p>

                {(isOfficialAdmin(auth) ||
                    (isOfficial(auth) && disabled && hasFileRef) ||
                    (isPublic(auth) && disabled && hasFileRef)) && (
                    <div className="cro-form in">
                      <CroField
                          className="full"
                          labelStyle={{ flexBasis: "auto" }}
                          title="Oznámení bylo podáno přes datovou schránku"
                          name="hasFileRef"
                          component={ReduxCheckbox}
                          disabled={disabled}
                      />
                    </div>
                )}
              </div>
          )}

        {/* === Point3 - pracovné pozície === */}
        {point3 && (
          <div className="statementForm__section">
            <CroSubhead title="Údaje o funkci a organizaci, ve které veřejný funkcionář působí" />
            <div className="cro-form in">
              <FieldArray
                  versionChangedClass={versionDiff ? getVersionChangedClass : null}
                  name="officialWorkingPositions"
                  component={WorkingPositions}
                  disabled={disabled}
                  canAddMore={true}
                  officialId={officialId}
                  isAdmin={isOfficialAdmin(auth)}
              />
            </div>
          </div>
        )}

          {/* === Druh oznámení a obdobie === */}
          <Element name="statementType" />
          <div className="statementForm__section">
            <CroSubhead
                title="Druh oznámení a období, za které se oznámení podává"
                helpEnum={H[`${t(type, promisedDos)}STATEMENT_TYPE`].r}
                disabled={disabled}
                onChange={() =>
                    isOfficial(auth) &&
                    !this.state.isFormTouched &&
                    this.hadndleIsFormTouch()
                }
            />
            <div className="cro-form in">
              {onlyOldSenator && (
                  <CroField
                      className={`full ${getVersionChangedClass('type_senator')}`}
                      title="Druh oznámení"
                      name="type_senator"
                      component={Select}
                      onChange={() =>
                          isOfficial(auth) &&
                          !this.state.isFormTouched &&
                          this.hadndleIsFormTouch()
                      }
                      items={this.filteredStmtTypes(
                          isNewState
                              ? StatementTypeSenatorOnly
                              : StatementTypeSenatorWithPoint3,
                      )}
                      fullWidth
                      disabled={disabled}
                      validate={[V.required]}
                      helpEnum={H.STATEMENT_TYPE.r}
                      helpIconStyle={{ marginLeft: 0 }}
                  />
              )}
              {senator && !senatorAndOthers && oldSenator && !onlyOldSenator && (
                  <CroField
                      className={`full ${getVersionChangedClass('type_senator')}`}
                      title="Druh oznámení"
                      name="type_senator"
                      component={Select}
                      onChange={() =>
                          isOfficial(auth) &&
                          !this.state.isFormTouched &&
                          this.hadndleIsFormTouch()
                      }
                      items={this.filteredStmtTypes(
                          hasPoint3 && !isNewState
                              ? StatementTypeSenatorWithPoint3
                              : StatementTypeSenatorNoPoint3,
                      )}
                      fullWidth
                      disabled={disabled}
                      validate={[V.required]}
                      helpEnum={H.STATEMENT_TYPE.r}
                      helpIconStyle={{ marginLeft: 0 }}
                  />
              )}
              {senatorAndOthers && oldSenator && !onlyOldSenator && (
                  <CroField
                      className={`full ${getVersionChangedClass('type_senator')}`}
                      title="Druh oznámení"
                      name="type_senator"
                      component={Select}
                      onChange={() =>
                          isOfficial(auth) &&
                          !this.state.isFormTouched &&
                          this.hadndleIsFormTouch()
                      }
                      items={this.filteredStmtTypes(
                          isNewState
                              ? StatementTypeSenatorAndOthers
                              : dosStatement
                                  ? StatementTypeSenatorWithPoint3
                                  : StatementTypeSenatorAndOthersWithPoint3,
                      )}
                      fullWidth
                      disabled={disabled}
                      validate={[V.required]}
                      helpEnum={H.STATEMENT_TYPE.r}
                      helpIconStyle={{ marginLeft: 0 }}
                  />
              )}
              {(senator || senatorAndOthers) && !oldSenator && (
                  <CroField
                      className={`full ${getVersionChangedClass('type')}`}
                      title="Druh oznámení"
                      name="type"
                      component={Select}
                      onChange={() =>
                          isOfficial(auth) &&
                          !this.state.isFormTouched &&
                          this.hadndleIsFormTouch()
                      }
                      items={this.filteredStmtTypes(
                          isNewState
                              ? StatementTypeNoPt3
                              : hasPoint3
                                  ? StatementTypeDeputySenatorAndOthers
                                  : StatementTypeDeputy,
                      )}
                      fullWidth
                      disabled={disabled}
                      validate={[V.required]}
                      helpEnum={H.STATEMENT_TYPE.r}
                      helpIconStyle={{ marginLeft: 0 }}
                  />
              )}
              {deputy && promiseDocumented && (
                  <CroField
                      className={`full ${getVersionChangedClass('type')}`}
                      title="Druh oznámení"
                      name="type"
                      component={Select}
                      onChange={() =>
                          isOfficial(auth) &&
                          !this.state.isFormTouched &&
                          this.hadndleIsFormTouch()
                      }
                      items={this.filteredStmtTypes(
                          isNewState ? StatementTypeDeputy : StatementTypeDeputyOld,
                      )}
                      fullWidth
                      disabled={disabled}
                      validate={[V.required]}
                      helpEnum={H.STATEMENT_TYPE.r}
                      helpIconStyle={{ marginLeft: 0 }}
                  />
              )}
              {deputy && !promiseDocumented && (
                  <CroField
                      className={`full ${getVersionChangedClass('type')}`}
                      title="Druh oznámení"
                      name="type"
                      component={Select}
                      onChange={() =>
                          isOfficial(auth) &&
                          !this.state.isFormTouched &&
                          this.hadndleIsFormTouch()
                      }
                      items={this.filteredStmtTypes(StatementTypeDeputy)}
                      fullWidth
                      disabled={disabled}
                      validate={[V.required]}
                      helpEnum={H.STATEMENT_TYPE.r}
                      helpIconStyle={{ marginLeft: 0 }}
                  />
              )}
              {deputyAndOthers && !senatorAndOthers && (
                  <CroField
                      className={`full ${getVersionChangedClass('type')}`}
                      title="Druh oznámení"
                      name="type"
                      component={Select}
                      onChange={() =>
                          isOfficial(auth) &&
                          !this.state.isFormTouched &&
                          this.hadndleIsFormTouch()
                      }
                      items={this.filteredStmtTypes(
                          isNewState
                              ? StatementTypeNoPt3
                              : StatementTypeDeputySenatorAndOthers,
                      )}
                      fullWidth
                      disabled={disabled}
                      validate={[V.required]}
                      helpEnum={H.STATEMENT_TYPE.r}
                      helpIconStyle={{ marginLeft: 0 }}
                  />
              )}
              {!senator && !senatorAndOthers && !deputy && !deputyAndOthers && (
                  <CroField
                      className={`full ${getVersionChangedClass('type')}`}
                      title="Druh oznámení"
                      name="type"
                      component={Select}
                      onChange={() =>
                          isOfficial(auth) &&
                          !this.state.isFormTouched &&
                          this.hadndleIsFormTouch()
                      }
                      items={this.filteredStmtTypes(
                          isNewState ? StatementTypeNoPt3 : StatementType,
                      )}
                      fullWidth
                      disabled={disabled}
                      validate={[V.required]}
                      helpEnum={H.STATEMENT_TYPE.r}
                      helpIconStyle={{ marginLeft: 0 }}
                  />
              )}
              {oneOf(ongoing, outgoing, deputyStatement, point4) && (
                  <div className="cro-form in">
                    <CroField
                        className={`half ${getVersionChangedClass('fromDate')}`}
                        title="Období od"
                        name="fromDate"
                        component={DatePicker}
                        disabled={disabled}
                        validate={[V.required, V.beforeToday]}
                        helpEnum={H[`${t(type, promisedDos)}FROM_DATE`].r}
                    />
                    <CroField
                        className={`half ${getVersionChangedClass('toDate')}`}
                        title="do"
                        name="toDate"
                        component={DatePicker}
                        onChange={this.changeWPDateAndIsFormTouch}
                        disabled={disabled}
                        validate={[V.required, V.beforeToday]}
                        helpEnum={H[`${t(type, promisedDos)}TO_DATE`].r}
                    />
                    <Field
                        name="workingPositionDate"
                        component={Input}
                        type="hidden"
                        style={{ display: "none" }}
                    />
                  </div>
              )}
              {oneOf(ingoing) && (
                  <div className="cro-form in">
                    <CroField
                        className={`full ${getVersionChangedClass('fromDate')}`}
                        title="Datum zahájení výkonu funkce"
                        name="fromDate"
                        component={DatePicker}
                        onChange={this.changeWPDateAndIsFormTouch}
                        disabled={disabled}
                        validate={[V.required, V.beforeToday]}
                        helpEnum={H[`${t(type, promisedDos)}WP_DATE`].r}
                    />
                    <Field
                        name="workingPositionDate"
                        component={Input}
                        type="hidden"
                        style={{ display: "none" }}
                    />
                  </div>
              )}
              {isOfficialAdmin(auth) && (
                  <div className="cro-form in">
                    <CroField
                        className={`full ${getVersionChangedClass('creationDate')}`}
                        title="Datum podání oznámení"
                        name="creationDate"
                        component={DatePicker}
                        disabled={disabled}
                        validate={[V.required, V.beforeToday]}
                    />
                  </div>
              )}
              {isOfficialAdmin(auth) && [StatementStateRaw.ACCEPT, StatementStateRaw.INCOMPLETE].includes(state) && (
                  <div className="cro-form in">
                    <CroField
                        className="full"
                        title="Viditelnost"
                        name="visibility"
                        component={Select}
                        disabled={readOnly}
                        items={Visibility.filter(v => v.id !== "PUBLIC")}
                        fullWidth
                    />
                  </div>
              )}
              {isOfficial(auth) && lastModified && !isNew && (
                  <div className="cro-form in">
                    <CroField
                        className="full"
                        title="Datum úpravy oznámení"
                        name="lastModified"
                        component={DatePicker}
                        disabled={true}
                    />
                  </div>
              )}
              {!disabled && oneOf(ingoing) && workingPositions[0] && workingPositions[0].start && new Date() < new Date(workingPositions[0].start) && (
                  <div className="cro-form in">
                      <p style={{ color: "#e65100", backgroundColor: "#fff3e0", padding: "12px 16px", borderRadius: 4, border: "1px solid #ffcc80" }}>
                          <strong>
                              Pozor, podáváte oznámení ke dni předcházejícímu dni zahájení
                              výkonu funkce
                          </strong>
                      </p>
                  </div>
              )}
            </div>
          </div>

        {/* === Pracovné pozície (non-point3) === */}
        {!point3 && (
          <div className="statementForm__section">
            <CroSubhead title="Údaje o funkci a organizaci, ve které veřejný funkcionář působí" />
            <div className="cro-form in">
              <FieldArray
                  versionChangedClass={versionDiff ? getVersionChangedClass : null}
                  name="officialWorkingPositions"
                  component={WorkingPositions}
                  disabled={disabled}
                  canAddMore={ongoing || point4}
                  officialId={officialId}
                  isAdmin={isOfficialAdmin(auth)}
                  onChangeFunction={
                      isOfficial(auth) &&
                      !this.state.isFormTouched &&
                      this.hadndleIsFormTouch
                  }
              />
            </div>
          </div>
        )}

        {/* start */}
        {!hasFileRef ? (
          <div className="cro-form in">
            {/* === Oznámení o činnostech === */}
            {oneOf(ingoing, ongoing, outgoing, point3, deputyStatement) && (
              <div className="statementForm__section">
                <CroSubhead title="Oznámení o činnostech" />
                <div className="cro-form in">
                  <div className="croSubheadCheck__header">
                    <span>Ano</span>
                    <span>Ne</span>
                  </div>
                  {this.se(naturalPersonBusinessesEnabled) && (
                    <Field
                      name="naturalPersonBusinessesEnabled"
                      component={CroSubheadWithCheck}
                      changeArray={this.changeArray("naturalPersonBusinesses")}
                      disabled={disabled}
                      title={
                        "Podnikání nebo provozování jiné samostatné výdělečné činnosti"
                      }
                      helpEnum={
                        H[`${t(type, promisedDos)}NATURAL_PERSON_BUSINESS`].r
                      }
                      validate={[V.required]}
                    />
                  )}
                  {this.se(naturalPersonBusinessesEnabled) &&
                    naturalPersonBusinessesEnabled && (
                      <FieldArray
                        versionChangedClass={versionDiff ? getVersionChangedClass : null}
                        noPublicLogged={noPublicLogged}
                        isLogged={isLogged(auth)}
                        name="naturalPersonBusinesses"
                        component={Bussiness}
                        disabled={disabled}
                        t={t(type, promisedDos)}
                        deputyStatement={deputyStatement}
                        dos={promisedDos}
                        defaultCountry={defaultCountry}
                        isPublicStatement={isPublicStatement}
                        onICOChange={(index, val) =>
                          this.handleIcoLookup("business", index, val)
                        }
                        aresErrors={aresErrors.business}
                      />
                    )}

                  {this.se(legalBusinessAssociatesEnabled) && (
                    <Field
                      name="legalBusinessAssociatesEnabled"
                      component={CroSubheadWithCheck}
                      changeArray={this.changeArray("legalBusinessAssociates")}
                      disabled={disabled}
                      title="Společník nebo člen podnikající právnické osoby"
                      helpEnum={
                        H[`${t(type, promisedDos)}LEGAL_BUSINESS_ASSOCIATES`].r
                      }
                      validate={[V.required]}
                    />
                  )}
                  {this.se(legalBusinessAssociatesEnabled) &&
                    legalBusinessAssociatesEnabled && (
                      <FieldArray
                        versionChangedClass={versionDiff ? getVersionChangedClass : null}
                        noPublicLogged={noPublicLogged}
                        isLogged={isLogged(auth)}
                        name="legalBusinessAssociates"
                        component={Associates}
                        disabled={disabled}
                        t={t(type, promisedDos)}
                        deputyStatement={deputyStatement}
                        defaultCountry={defaultCountry}
                        isPublicStatement={isPublicStatement}
                        onICOChange={(index, val) =>
                          this.handleIcoLookup("associates", index, val)
                        }
                        aresErrors={aresErrors.associates}
                      />
                    )}

                  {this.se(organizationMemberEnabled) && (
                    <Field
                      name="organizationMemberEnabled"
                      component={CroSubheadWithCheck}
                      changeArray={this.changeArray("organizationMember")}
                      disabled={disabled}
                      title="Člen statutárního orgánu, člen řídícího, dozorčího nebo kontrolního orgánu podnikající právnické osoby"
                      helpEnum={
                        H[`${t(type, promisedDos)}ORGANIZATION_MEMBER`].r
                      }
                      validate={[V.required]}
                    />
                  )}
                  {this.se(organizationMemberEnabled) &&
                    organizationMemberEnabled && (
                      <FieldArray
                        versionChangedClass={versionDiff ? getVersionChangedClass : null}
                        noPublicLogged={noPublicLogged}
                        isLogged={isLogged(auth)}
                        name="organizationMember"
                        component={OrganizationMember}
                        disabled={disabled}
                        t={t(type, promisedDos)}
                        defaultCountry={defaultCountry}
                        isPublicStatement={isPublicStatement}
                        onICOChange={(index, val) =>
                          this.handleIcoLookup("orgMember", index, val)
                        }
                        aresErrors={aresErrors.orgMember}
                      />
                    )}

                        {!promisedDos && this.se(mediaEnabled) && (
                            <Field
                                name="mediaEnabled"
                                component={CroSubheadWithCheck}
                                changeArray={this.changeArray("media")}
                                disabled={disabled}
                                title="Provozování rozhlasového nebo televizního vysílání nebo vydávání periodického tisku"
                                helpEnum={H[`${t(type, promisedDos)}MEDIUM`].r}
                                validate={[V.required]}
                            />
                        )}
                        {!promisedDos && this.se(mediaEnabled) && mediaEnabled && (
                            <FieldArray
                                versionChangedClass={versionDiff ? getVersionChangedClass : null}
                                noPublicLogged={noPublicLogged}
                                isLogged={isLogged(auth)}
                                name="media"
                                component={Media}
                                disabled={disabled}
                                t={t(type, promisedDos)}
                                defaultCountry={defaultCountry}
                                isPublicStatement={isPublicStatement}
                                onICOChange={(index, val) =>
                                  this.handleIcoLookup("media", index, val)
                                }
                                aresErrors={aresErrors.media}
                            />
                        )}

                        {this.se(otherContractsEnabled) && (
                            <Field
                                name="otherContractsEnabled"
                                component={CroSubheadWithCheck}
                                changeArray={this.changeArray("otherContracts")}
                                disabled={disabled}
                                title="Další činnost v pracovněprávním nebo obdobném vztahu nebo ve služebním poměru, nejde-li o vztah nebo poměr, v němž působí jako veřejný funkcionář"
                                helpEnum={H[`${t(type, promisedDos)}OTHER_CONTRACTS`].r}
                                validate={[V.required]}
                            />
                        )}
                        {this.se(otherContractsEnabled) && otherContractsEnabled && (
                            <FieldArray
                                versionChangedClass={versionDiff ? getVersionChangedClass : null}
                                noPublicLogged={noPublicLogged}
                                isLogged={isLogged(auth)}
                                name="otherContracts"
                                component={OtherContracts}
                                dos={promisedDos}
                                disabled={disabled}
                                t={t(type, promisedDos)}
                                change={this.props.change}
                                defaultCountry={defaultCountry}
                                isPublicStatement={isPublicStatement}
                                ongoing={ongoing}
                                outgoing={outgoing}
                                onICOChange={(index, val) =>
                                  this.handleIcoLookup("otherContracts", index, val)
                                }
                                aresErrors={aresErrors.otherContracts}
                            />
                        )}
                      </div>
                    </div>
                )}

            {/* === Majetok pred nástupom (ingoing) === */}
            {oneOf(ingoing) && (
              <div className="statementForm__section">
                <CroSubhead title="Oznámení o majetku, který veřejný funkcionář vlastní ke dni předcházejícímu dni zahájení výkonu funkce" />
                <div className="cro-form in">
                  <div className="croSubheadCheck__header">
                    <span>Ano</span>
                    <span>Ne</span>
                  </div>
                  {this.se(realtiesBeforeEnabled) && (
                    <div className="cro-form in">
                      <Field
                        name="realtiesBeforeEnabled"
                        component={CroSubheadWithCheck}
                        changeArray={this.changeArray("realtiesBefore")}
                        disabled={disabled}
                        title={"Věci nemovité"}
                        helpEnum={H[`${t(type, promisedDos)}REALTY`].r}
                        tooltipPosition="top-right"
                        validate={[V.required]}
                      />
                      {realtiesBeforeEnabled && (
                        <FieldArray
                          versionChangedClass={versionDiff ? getVersionChangedClass : null}
                          noPublicLogged={noPublicLogged}
                          name="realtiesBefore"
                          component={Realties}
                          disabled={disabled}
                          t={t(type, promisedDos)}
                          workingPositions={workingPositionsAll}
                          isPublicStatement={isPublicStatement}
                          form={FORM_NAME}
                          ingoing={ingoing}
                          change={change}
                          creationDate={creationDate}
                        />
                      )}
                    </div>
                  )}

                        {this.se(commercialPapersBeforeEnabled) && (
                            <Field
                                name="commercialPapersBeforeEnabled"
                                component={CroSubheadWithCheck}
                                changeArray={this.changeArray("commercialPapersBefore")}
                                disabled={disabled}
                                title="Cenné papíry, zaknihované cenné papíry nebo práva s nimi spojená"
                                helpEnum={H[`${t(type, promisedDos)}COMMERCIAL_PAPERS`].r}
                                validate={[V.required]}
                            />
                        )}
                        {this.se(commercialPapersBeforeEnabled) &&
                            commercialPapersBeforeEnabled && (
                                <FieldArray
                                    versionChangedClass={versionDiff ? getVersionChangedClass : null}
                                    noPublicLogged={noPublicLogged}
                                    name="commercialPapersBefore"
                                    component={CommercialPapers}
                                    disabled={disabled}
                                    t={t(type, promisedDos)}
                                    isPublicStatement={isPublicStatement}
                                    dos={promisedDos}
                                />
                            )}

                  {this.se(corporationSharesBeforeEnabled) && (
                    <Field
                      name="corporationSharesBeforeEnabled"
                      component={CroSubheadWithCheck}
                      changeArray={this.changeArray("corporationSharesBefore")}
                      disabled={disabled}
                      title="Podíl v obchodní korporaci nepředstavovaný cenným papírem nebo zaknihovaným cenným papírem"
                      helpEnum={H[`${t(type, promisedDos)}CORPORATION_SHARE`].r}
                      validate={[V.required]}
                    />
                  )}
                  {this.se(corporationSharesBeforeEnabled) &&
                    corporationSharesBeforeEnabled && (
                      <FieldArray
                        versionChangedClass={versionDiff ? getVersionChangedClass : null}
                        noPublicLogged={noPublicLogged}
                        isLogged={isLogged(auth)}
                        name="corporationSharesBefore"
                        component={CorporationShares}
                        disabled={disabled}
                        t={t(type, promisedDos)}
                        ingoing={ingoing}
                        defaultCountry={defaultCountry}
                        isPublicStatement={isPublicStatement}
                        dos={promisedDos}
                        onICOChange={(index, val) =>
                          this.handleIcoLookup("corpSharesBefore", index, val)
                        }
                        aresErrors={aresErrors.corpSharesBefore}
                      />
                    )}

                  {this.se(chattelsBeforeEnabled) && (
                    <Field
                      name="chattelsBeforeEnabled"
                      component={CroSubheadWithCheck}
                      changeArray={this.changeArray("chattelsBefore")}
                      disabled={disabled}
                      title={
                        "Jiné věci movité určené podle druhu, jejichž cena, která je v daném místě a čase obvyklá, přesahuje v jednotlivém případě částku 500\u00A0000,- Kč"
                      }
                      helpEnum={H[`${t(type, promisedDos)}CHATTEL`].r}
                      validate={[V.required]}
                    />
                  )}
                  {this.se(chattelsBeforeEnabled) && chattelsBeforeEnabled && (
                    <FieldArray
                      versionChangedClass={versionDiff ? getVersionChangedClass : null}
                      noPublicLogged={noPublicLogged}
                      name="chattelsBefore"
                      component={Chattels}
                      disabled={disabled}
                      t={t(type, promisedDos)}
                      ingoing={ingoing}
                      isPublicStatement={isPublicStatement}
                      dos={promisedDos}
                      isCity={isCity}
                      isVillage={isVillage}
                    />
                  )}
                </div>
              </div>
            )}

            {/* === Majetok nadobudnutý (ongoing/outgoing/point3/deputy) === */}
            {oneOf(ongoing, outgoing, point3, deputyStatement) && (
              <div className="statementForm__section">
                {!promisedDos &&
                  (oneOf(point3) ? (
                    <CroSubhead title="Oznámení o majetku, který veřejný funkcionář vlastní ke dni 1. září 2017" />
                  ) : (
                    <CroSubhead title="Oznámení o majetku, který veřejný funkcionář nabyl v průběhu výkonu funkce" />
                  ))}
                {promisedDos && (
                  <CroSubhead title="Oznámení o majetku, který veřejný funkcionář nabyl v průběhu výkonu funkce za období, za které oznámení podává" />
                )}
                <div className="cro-form in">
                  <div className="croSubheadCheck__header">
                    <span>Ano</span>
                    <span>Ne</span>
                  </div>
                  {this.se(realtiesEnabled) && (
                    <div className="cro-form in">
                      <Field
                        name="realtiesEnabled"
                        component={CroSubheadWithCheck}
                        changeArray={this.changeArray("realties")}
                        disabled={disabled}
                        title="Věci nemovité"
                        helpEnum={H[`${t(type, promisedDos)}REALTY`].r}
                        tooltipPosition="top-right"
                        validate={[V.required]}
                      />
                      {realtiesEnabled && (
                        <FieldArray
                          versionChangedClass={versionDiff ? getVersionChangedClass : null}
                          noPublicLogged={noPublicLogged}
                          name="realties"
                          component={Realties}
                          disabled={disabled}
                          ongoing={ongoing}
                          dos={promisedDos}
                          workingPositions={workingPositionsAll}
                          t={t(type, promisedDos)}
                          point3={point3}
                          outgoing={outgoing}
                          isPublicStatement={isPublicStatement}
                          form={FORM_NAME}
                          change={change}
                          creationDate={creationDate}
                        />
                      )}
                    </div>
                  )}

                        {this.se(commercialPapersEnabled) && (
                            <Field
                                name="commercialPapersEnabled"
                                component={CroSubheadWithCheck}
                                changeArray={this.changeArray("commercialPapers")}
                                disabled={disabled}
                                title={
                                  !promisedDos
                                      ? "Cenné papíry, zaknihované cenné papíry nebo práva s nimi spojená"
                                      : "Cenné papíry, zaknihované cenné papíry nebo práva s nimi spojená, pokud celková výše kupní ceny cenných papírů, zaknihovaných cenných papírů nebo práv s nimi spojených od jednoho emitenta v době nabytí přesahuje částku 50 000,- Kč anebo částku 100 000,- Kč v případě více emitentů"
                                }
                                helpEnum={H[`${t(type, promisedDos)}COMMERCIAL_PAPERS`].r}
                                validate={[V.required]}
                            />
                        )}
                        {this.se(commercialPapersEnabled) &&
                            commercialPapersEnabled && (
                                <FieldArray
                                    versionChangedClass={versionDiff ? getVersionChangedClass : null}
                                    noPublicLogged={noPublicLogged}
                                    name="commercialPapers"
                                    component={CommercialPapers}
                                    disabled={disabled}
                                    ongoing={ongoing}
                                    outgoing={outgoing}
                                    dos={promisedDos}
                                    wps={workingPositions.length}
                                    t={t(type, promisedDos)}
                                    point3={point3}
                                    isPublicStatement={isPublicStatement}
                                />
                            )}

                  {this.se(corporationSharesEnabled) && (
                    <Field
                      name="corporationSharesEnabled"
                      component={CroSubheadWithCheck}
                      changeArray={this.changeArray("corporationShares")}
                      disabled={disabled}
                      title={
                        !promisedDos
                          ? "Podíl v obchodní korporaci nepředstavovaný cenným papírem nebo zaknihovaným cenným papírem"
                          : "Podíl v obchodní korporaci nepředstavovaný cenným papírem nebo zaknihovaným cenným papírem, pokud hodnota tohoto podílu přesahuje částku 50 000,- Kč anebo částku 100 000,- Kč, jde-li o podíly u více obchodních korporací"
                      }
                      helpEnum={H[`${t(type, promisedDos)}CORPORATION_SHARE`].r}
                      validate={[V.required]}
                    />
                  )}
                  {this.se(corporationSharesEnabled) &&
                    corporationSharesEnabled && (
                      <FieldArray
                        versionChangedClass={versionDiff ? getVersionChangedClass : null}
                        noPublicLogged={noPublicLogged}
                        isLogged={isLogged(auth)}
                        name="corporationShares"
                        component={CorporationShares}
                        disabled={disabled}
                        ongoing={ongoing}
                        deputyStatement={deputyStatement}
                        dos={promisedDos}
                        wps={workingPositions.length}
                        t={t(type, promisedDos)}
                        point3={point3}
                        outgoing={outgoing}
                        defaultCountry={defaultCountry}
                        isPublicStatement={isPublicStatement}
                        onICOChange={(index, val) =>
                          this.handleIcoLookup("corpShares", index, val)
                        }
                        aresErrors={aresErrors.corpShares}
                      />
                    )}

                        {this.se(chattelsEnabled) && (
                            <Field
                                name="chattelsEnabled"
                                component={CroSubheadWithCheck}
                                changeArray={this.changeArray("chattels")}
                                disabled={disabled}
                                title={
                                  !promisedDos
                                      ? oneOf(point3)
                                          ? "Jiné věci movité určené podle druhu, jejichž cena, která je v daném místě a čase obvyklá, přesahuje v jednotlivém případě částku 500 000,- Kč"
                                          : "Jiné věci movité určené podle druhu, nabyté v průběhu kalendářního roku, jejichž hodnota ve svém souhrnu, do něhož se nezapočítávají věci, jejichž hodnota je nižší než 50 000,- Kč, přesáhla částku 500\u00A0000,- Kč."
                                      : "Věci movité nabyté v průběhu kalendářního roku, jejichž hodnota ve svém souhrnu, do něhož se nezapočítávají věci, jejichž cena je nižší než 25 000,- Kč, přesáhla částku 500\u00A0000,- Kč"
                                }
                                helpEnum={H[`${t(type, promisedDos)}CHATTEL`].r}
                                validate={[V.required]}
                            />
                        )}
                        {this.se(chattelsEnabled) && chattelsEnabled && (
                            <FieldArray
                                versionChangedClass={versionDiff ? getVersionChangedClass : null}
                                noPublicLogged={noPublicLogged}
                                name="chattels"
                                component={Chattels}
                                disabled={disabled}
                                ongoing={ongoing}
                                outgoing={outgoing}
                                dos={promisedDos}
                                wps={workingPositions.length}
                                t={t(type, promisedDos)}
                                point3={point3}
                                isPublicStatement={isPublicStatement}
                                isCity={isCity}
                                isVillage={isVillage}
                            />
                        )}
                      </div>
                    </div>
                )}

                {/* === Príjmy a záväzky (deputyStatement) === */}
                {oneOf(deputyStatement) && (
                    <div className="statementForm__section">
                      <CroSubhead title="Oznámení o příjmech a závazcích" />
                      <div className="cro-form in">
                        {this.se(incomesEnabled) && (
                            <Field
                                name="incomesEnabled"
                                component={CroSubheadWithCheck}
                                changeArray={this.changeArray("incomes")}
                                disabled={disabled}
                                title="Jakékoliv peněžité příjmy nebo jiné majetkové výhody a dary, pokud jejich souhrnná výše přesáhne v kalendářním roce částku 100 000,- Kč"
                                helpEnum={H[`${t(type, promisedDos)}INCOME`].r}
                                validate={[V.required]}
                            />
                        )}
                        {this.se(incomesEnabled) && incomesEnabled && (
                            <FieldArray
                                versionChangedClass={versionDiff ? getVersionChangedClass : null}
                                noPublicLogged={noPublicLogged}
                                isLogged={isLogged(auth)}
                                isPublic={isPublic(auth)}
                                name="incomes"
                                component={Incomes}
                                onSourceCheck={this.onSourceCheck}
                                point4={point4}
                                ongoing={ongoing}
                                disabled={disabled}
                                t={t(type, promisedDos)}
                                defaultCountry={defaultCountry}
                                isPublicStatement={isPublicStatement}
                                onICOChange={(index, val) =>
                                  this.handleIcoLookup("incomes", index, val)
                                }
                                aresErrors={aresErrors.incomes}
                            />
                        )}

                        {this.se(liabilitiesEnabled) && (
                            <Field
                                name="liabilitiesEnabled"
                                component={CroSubheadWithCheck}
                                changeArray={this.changeArray("liabilities")}
                                disabled={disabled}
                                title={
                                  ingoing
                                      ? "Nesplacené závazky, zejména půjčky a úvěry, pokud jejich výše ke dni předcházejícímu dni zahájení výkonu funkce přesahuje v jednotlivém případě částku 100 000,- Kč"
                                      : "Nesplacené závazky, zejména půjčky a úvěry, pokud jejich souhrnná výše přesáhla ke dni 1. září kalendářního roku částku 100 000,- Kč"
                                }
                                helpEnum={H[`${t(type, promisedDos)}LIABILITY`].r}
                                validate={[V.required]}
                            />
                        )}
                        {this.se(liabilitiesEnabled) && liabilitiesEnabled && (
                            <FieldArray
                                versionChangedClass={versionDiff ? getVersionChangedClass : null}
                                noPublicLogged={noPublicLogged}
                                name="liabilities"
                                component={Liabilities}
                                onSourceCheck={this.onSourceCheck}
                                disabled={disabled}
                                t={t(type, promisedDos)}
                                defaultCountry={defaultCountry}
                                isPublicStatement={isPublicStatement}
                                dos={promisedDos}
                                isCity={isCity}
                                isVillage={isVillage}
                                onICOChange={(index, val) =>
                                  this.handleIcoLookup("liabilities", index, val)
                                }
                                aresErrors={aresErrors.liabilities}
                            />
                        )}
                      </div>
                    </div>
                )}

            {/* === Záväzky (ingoing, point3) === */}
            {this.se(liabilitiesEnabled) && oneOf(ingoing, point3) && (
              <div className="statementForm__section">
                <CroSubhead title="Oznámení o závazcích" />
                <div className="cro-form in">
                  <div className="croSubheadCheck__header">
                    <span>Ano</span>
                    <span>Ne</span>
                  </div>
                  <Field
                    name="liabilitiesEnabled"
                    component={CroSubheadWithCheck}
                    changeArray={this.changeArray("liabilities")}
                    disabled={disabled}
                    title={
                      ingoing
                        ? "Nesplacené závazky, zejména půjčky a úvěry, pokud jejich výše ke dni předcházejícímu dni zahájení výkonu funkce přesahuje v jednotlivém případě částku 100 000,- Kč"
                        : "Nesplacené závazky, zejména půjčky a úvěry, pokud jejich souhrnná výše přesáhla ke dni 1. září 2017 částku 100 000,- Kč"
                    }
                    helpEnum={H[`${t(type, promisedDos)}LIABILITY`].r}
                    validate={[V.required]}
                  />
                  {liabilitiesEnabled && (
                    <FieldArray
                      versionChangedClass={versionDiff ? getVersionChangedClass : null}
                      noPublicLogged={noPublicLogged}
                      name="liabilities"
                      component={Liabilities}
                      onSourceCheck={this.onSourceCheck}
                      disabled={disabled}
                      t={t(type, promisedDos)}
                      defaultCountry={defaultCountry}
                      isPublicStatement={isPublicStatement}
                      dos={promisedDos}
                      isCity={isCity}
                      isVillage={isVillage}
                      onICOChange={(index, val) =>
                        this.handleIcoLookup("liabilities", index, val)
                      }
                      aresErrors={aresErrors.liabilities}
                    />
                  )}
                </div>
              </div>
            )}

            {/* === Príjmy (ongoing, outgoing, point4) === */}
            {this.se(incomesEnabled) && oneOf(ongoing, outgoing, point4) && (
              <div className="statementForm__section">
                {oneOf(point4) ? (
                  <CroSubhead title="Oznámení o příjmech" />
                ) : (
                  <CroSubhead title="Oznámení o příjmech a závazcích" />
                )}
                <div className="cro-form in">
                  <Field
                    name="incomesEnabled"
                    component={CroSubheadWithCheck}
                    changeArray={this.changeArray("incomes")}
                    disabled={disabled}
                    title={
                      point4
                        ? "Jakékoli peněžité příjmy nebo jiné majetkové výhody a dary, pokud jejich souhrnná výše přesáhla v kalendářním roce 2017 částku 100 000 Kč"
                        : outgoing
                          ? "Jakékoliv peněžité příjmy nebo jiné majetkové výhody a dary, pokud jejich souhrnná výše přesáhla ke dni ukončení výkonu funkce částku 100 000,- Kč"
                          : "Jakékoliv peněžité příjmy nebo jiné majetkové výhody a dary, pokud jejich souhrnná výše přesáhne v kalendářním roce částku 100 000,- Kč"
                    }
                    helpEnum={H[`${t(type, promisedDos)}INCOME`].r}
                    validate={[V.required]}
                  />
                  {incomesEnabled && (
                    <FieldArray
                      versionChangedClass={versionDiff ? getVersionChangedClass : null}
                      noPublicLogged={noPublicLogged}
                      isLogged={isLogged(auth)}
                      isPublic={isPublic(auth)}
                      name="incomes"
                      component={Incomes}
                      onSourceCheck={this.onSourceCheck}
                      point4={point4}
                      ongoing={ongoing}
                      outgoing={outgoing}
                      disabled={disabled}
                      t={t(type, promisedDos)}
                      defaultCountry={defaultCountry}
                      isPublicStatement={isPublicStatement}
                      isVillage={isVillage}
                      isReleased={isReleased}
                      onICOChange={(index, val) =>
                        this.handleIcoLookup("incomes", index, val)
                      }
                      aresErrors={aresErrors.incomes}
                    />
                  )}
                </div>
              </div>
            )}

            {/* === Záväzky (ongoing, outgoing) === */}
            {this.se(liabilitiesEnabled) && oneOf(ongoing, outgoing) && (
              <div className="statementForm__section">
                <div className="cro-form in">
                  <Field
                    name="liabilitiesEnabled"
                    component={CroSubheadWithCheck}
                    changeArray={this.changeArray("liabilities")}
                    disabled={disabled}
                    validate={[V.required]}
                    title={
                      !outgoing
                        ? "Nesplacené závazky, zejména půjčky a úvěry, pokud jejich souhrnná výše přesáhla ke dni 31. prosince kalendářního roku, za který se oznámení podává, částku 100 000,- Kč"
                        : "Nesplacené závazky, zejména půjčky a úvěry, pokud jejich souhrnná výše ke dni ukončení výkonu funkce přesáhla částku 100 000,- Kč"
                    }
                    helpEnum={H[`${t(type, promisedDos)}LIABILITY`].r}
                  />
                  {liabilitiesEnabled && (
                    <FieldArray
                      versionChangedClass={versionDiff ? getVersionChangedClass : null}
                      noPublicLogged={noPublicLogged}
                      name="liabilities"
                      component={Liabilities}
                      onSourceCheck={this.onSourceCheck}
                      disabled={disabled}
                      t={t(type, promisedDos)}
                      defaultCountry={defaultCountry}
                      isPublicStatement={isPublicStatement}
                      dos={promisedDos}
                      ongoing={ongoing}
                      outgoing={outgoing}
                      isCity={isCity}
                      isVillage={isVillage}
                      onICOChange={(index, val) =>
                        this.handleIcoLookup("liabilities", index, val)
                      }
                      aresErrors={aresErrors.liabilities}
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="statementForm__section">
            <CroFiles
              publicLabel="Soubor s veřejným oznámením"
              privateLabel="Soubor s interním oznámením"
              publicButtonLabel="Importovat veřejné oznámení"
              privateButtonLabel="Importovat interní oznámení"
              fileType={StatementFileType.STATEMENT}
              required
              submitFailed={submitFailed}
              disabled={disabled}
              dispatch={dispatch}
              form={FORM_NAME}
            />
          </div>
        )}

        {/* end */}

        {/* Kontroly */}
        {(isOfficialAdmin(auth) || isAdmin(auth)) && !readOnly && !isNew && (
          <div className="statementForm__section">
            <CroLabeledCmp title="Kontroly">
              <InspectionStatementsGrid
                  gridName="officialInspectionStatementGrid"
                  url={inspectionsUrl}
                  onRowClick={this.onOpenInspection}
              />
            </CroLabeledCmp>
          </div>
        )}

        {/* === Footer === */}
        <div className="statementForm__footer no-print">
          <div className="statementForm__footerInner">
            {error && <div className="error">{error}</div>}
            {!this.props.valid && this.props.submitFailed && !error && !invalidFormFields && (
              <div className="error">Povinná pole nejsou správně vyplněna.</div>
            )}
            {!this.props.valid && !error && invalidFormFields && fullyLoaded && (
                <div className="error">Některá pole nejsou správně vyplněna.</div>
            )}
            {!disabled && (
              <div className="statementForm__hint">
                Povinná pole jsou označena hvězdičkou.
              </div>
            )}
            {isOfficial(auth) &&
              ([
                StatementStateRaw.NEW,
                StatementStateRaw.INCOMPLETE,
                StatementStateRaw.WRONG,
              ].includes(state) ||
                state === null) && (
                <InfoMessage>
                  <div>
                    Stisknutím tlačítka „ULOŽIT ROZPRACOVANÉ OZNÁMENÍ" se
                    oznámení převede do stavu „rozpracované" a lze jej dále
                    editovat.
                  </div>
                  <div>
                    Stisknutím tlačítka „ODESLAT OZNÁMENÍ DO REGISTRU" se
                    oznámení převede do stavu „odeslané", tj. odešle se do
                    Centrálního registru oznámení a už jej nadále nebude možné
                    editovat.
                  </div>
                  <div>
                    Stisknutím tlačítka „EXPORT DO PDF" se oznámení převede do
                    formátu *.pdf. Tento výstup může být využit pro zaslání
                    oznámení prostřednictvím datové schránky.
                  </div>
                </InfoMessage>
              )}
            {isOfficial(auth) &&
              ([
                StatementStateRaw.NEW,
                StatementStateRaw.INCOMPLETE,
                StatementStateRaw.WRONG,
              ].includes(state) ||
                state === null) && (
                <InfoMessage variant="warning">
                  <b>
                    Jsem si vědom/a, jaký „Druh oznámení" a za jakou „Funkci"
                    oznámení podávám.
                  </b>
                </InfoMessage>
              )}

              {readOnly && (
                <div className="statementForm__actions">
                  <Button
                    type="button"
                    style={styles.buttons}
                    label="Zpět"
                    onClick={this.goBack}
                  />
                </div>
              )}

              {!readOnly && (
                <div className="statementForm__actions">
                {!isOfficial(auth) && !isPublic(auth) && (
                  <Button
                    type="button"
                    style={styles.buttons}
                    label="Zpět"
                    onClick={this.goBack}
                  />
                )}
                {isOfficial(auth) && !disabled && (
                  <Button
                    type="button"
                    style={styles.buttons}
                    label="Uložit rozpracované oznámení"
                    disabled={submitting || disabled}
                    onClick={this.saveStatement}
                  />
                )}
                {isOfficialAdmin(auth) && (
                  <Button
                    type="button"
                    style={styles.buttons}
                    label="Uložit oznámení"
                    disabled={submitting || disabled}
                    onClick={handleSubmit(onSubmit)}
                  />
                )}
                {isOfficial(auth) &&
                  ([
                    StatementStateRaw.NEW,
                    StatementStateRaw.INCOMPLETE,
                    StatementStateRaw.WRONG,
                  ].includes(state) ||
                    state === null) && (
                    <Button
                      type="button"
                      style={styles.buttons}
                      label="Odeslat oznámení do registru"
                      disabled={submitting || disabled}
                      onClick={handleSubmit(onSend)}
                    />
                  )}
                {isOfficial(auth) &&
                  [StatementStateRaw.ACCEPT].includes(state) && !useAsTemplateDisabled && (
                    <Button
                      type="button"
                      style={styles.buttons}
                      label="Použít jako šablonu"
                      disabled={submitting}
                      onClick={this.cloneStatement}
                    />
                  )}
                {isInternal(auth) &&
                  [StatementStateRaw.ACCEPT, StatementStateRaw.WRONG].includes(
                    state,
                  ) && (
                    <Button
                      type="button"
                      style={styles.buttons}
                      label="Označit jako neúplné"
                      disabled={submitting}
                      onClick={onIncomplete}
                    />
                  )}
                {(isOfficial(auth) || isInternal(auth)) && (
                  <div className="no-print">
                    <Button
                      type="button"
                      style={styles.buttons}
                      label="Export do PDF"
                      disabled={submitting}
                      onClick={this.exportStatementToPdf}
                    />
                  </div>
                )}
                {isInternal(auth) && (
                  <div className="no-print">
                    <Button
                      type="button"
                      style={styles.buttons}
                      label="Export do PDF v rozsahu žadatelů o nahlížení"
                      disabled={submitting}
                      onClick={this.exportStatementToPdfRequest}
                    />
                  </div>
                )}
                </div>
              )}
          </div>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: FORM_NAME,
  validate: V.startBeforeEnd("fromDate", "toDate"),
})(asyncForm(StatementForm));
